import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/* eslint-disable camelcase */
import { SpecType, SubType, ElementType } from './interfaces';
import { getClient } from '@chegg/rio-sdk-web';
import { getOptUserProfileCookie } from '@chegg/utils';
import { getBillingCycleContentKey } from '../ContentUtil';
import { ExternalIdProductTypeMap } from '../../constants/Rio';
import getIsUpgradeEligible from '../getIsUpgradeEligible';
var rioClient;
export var initializeRioClient = function initializeRioClient(config, namespace) {
  // if client does not exist, it will return a new, uninitialized client
  rioClient = getClient(namespace);
  if (!rioClient.isInit && config) {
    rioClient.init(config);
  }
};
export var updateRioClient = function updateRioClient(config, namespace) {
  rioClient = getClient(namespace);
  config && rioClient.updateState(config);
};
export var updateRioView = function updateRioView(view, namespace) {
  rioClient = getClient(namespace);
  rioClient.updateState({
    view: view
  });
};
var rioSessionHasAllocation = function rioSessionHasAllocation(rioSessionAllocations, newAllocation) {
  return rioSessionAllocations.some(function (prevAllocation) {
    return prevAllocation.experiment_id === newAllocation.experiment_id && prevAllocation.variant_id === newAllocation.variant_id;
  });
};
export var updateRioClientExperiment = function updateRioClientExperiment(namespace) {
  var _getOptUserProfileCoo, _rioClient$stateManag;
  var arrayCookieComponents = decodeURIComponent((_getOptUserProfileCoo = getOptUserProfileCookie()) !== null && _getOptUserProfileCoo !== void 0 ? _getOptUserProfileCoo : '').split(',');
  var experiments = [];
  rioClient = getClient(namespace);
  var rioAllocationState =
  // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- these conditions are being kept to handle explicit test cases in rioHelper.ts, they may not be necessary (https://gitlab.com/chegginc/learning-services/web/chegg-web/-/merge_requests/14167#note_1888841701)
  ((_rioClient$stateManag = rioClient.stateManager) === null || _rioClient$stateManag === void 0 || (_rioClient$stateManag = _rioClient$stateManag.get()) === null || _rioClient$stateManag === void 0 ? void 0 : _rioClient$stateManag.experiments) || [];
  for (var cnt = 0; cnt < arrayCookieComponents.length; cnt++) {
    if (cnt !== 0) {
      var _arrayCookieComponent = arrayCookieComponents[cnt].split(':'),
        _arrayCookieComponent2 = _slicedToArray(_arrayCookieComponent, 2),
        experiment_id = _arrayCookieComponent2[0],
        variant_id = _arrayCookieComponent2[1];
      if (experiment_id && variant_id && !rioSessionHasAllocation(rioAllocationState, {
        experiment_id: experiment_id,
        variant_id: variant_id
      })) {
        experiments.push({
          experiment_id: experiment_id,
          variant_id: variant_id
        });
      }
    }
  }
  if (experiments.length) {
    rioClient.updateState({
      experiments: experiments
    });
  }
};
var getRioClient = function getRioClient(namespace) {
  rioClient = getClient(namespace);
  return rioClient;
};
export var sendRioEvent = function sendRioEvent(params) {
  var info = params.info,
    specType = params.specType,
    subType = params.subType,
    elementType = params.elementType,
    callback = params.callback,
    namespace = params.namespace,
    eventName = params.eventName,
    elementText = params.elementText,
    elementValue = params.elementValue,
    message_detail = params.message_detail,
    message_id = params.message_id,
    value = params.value,
    componentText = params.componentText,
    product_details = params.product_details,
    coupon_details = params.coupon_details,
    force = params.force,
    region_name = params.region_name,
    viewContext = params.viewContext;
  var logObj;
  switch (specType) {
    case SpecType.COMPONENT_VIEW:
      logObj = getLoadingEvent({
        eventName: eventName,
        info: info,
        specType: specType,
        value: value,
        componentText: componentText,
        product_details: product_details,
        force: force,
        region_name: region_name
      });
      break;
    case SpecType.INTERACTION:
      logObj = getLinkTracingEvent({
        info: info,
        specType: specType,
        subType: subType,
        elementType: elementType,
        elementText: elementText,
        elementValue: elementValue,
        force: force,
        region_name: region_name
      });
      break;
    case SpecType.SUCCESS:
      logObj = getSuccessEvent({
        info: info,
        specType: specType,
        force: force,
        coupon_details: coupon_details
      });
      break;
    case SpecType.NOTIFICATION:
      logObj = getNotificationEvent({
        subType: subType,
        specType: specType,
        info: info,
        message_detail: message_detail,
        message_id: message_id,
        force: force
      });
      break;
    case SpecType.PAGE_VIEW:
      logObj = getPageViewEvent(force, product_details);
      viewContext && updateRioView(viewContext, namespace);
      break;
    case SpecType.PURCHASE:
      var purchaseEvent = JSON.parse(info);
      logObj = getPurchaseEvent(purchaseEvent, force);
      break;
  }
  getRioClient(namespace);
  if (!rioClient.isInit && callback) {
    callback(logObj);
  } else {
    if (callback) {
      rioClient.sendEvent(logObj).then(function () {
        return callback(logObj);
      },
      // onSuccess
      function () {
        return callback(logObj);
      } // onFail
      );
    } else {
      rioClient.sendEvent(logObj);
    }
  }
};
var getLoadingEvent = function getLoadingEvent(_ref) {
  var info = _ref.info,
    value = _ref.value,
    componentText = _ref.componentText,
    product_details = _ref.product_details,
    force = _ref.force,
    region_name = _ref.region_name,
    eventName = _ref.eventName;
  return {
    type: SpecType.COMPONENT_VIEW,
    data: {
      component_view: {
        state: 'success',
        component: {
          name: info,
          type: SubType.COMPONENT,
          value: value,
          text: componentText,
          region_name: region_name
        }
      },
      products: product_details,
      event_name: eventName
    },
    version: 3,
    options: {
      force: force !== null && force !== void 0 ? force : true
    }
  };
};
var getPageViewEvent = function getPageViewEvent(force, productDetails) {
  return {
    type: SpecType.PAGE_VIEW,
    data: {
      products: productDetails
    },
    version: 3,
    options: {
      force: force !== null && force !== void 0 ? force : false
    }
  };
};
var getLinkTracingEvent = function getLinkTracingEvent(_ref2) {
  var info = _ref2.info,
    subType = _ref2.subType,
    elementType = _ref2.elementType,
    elementText = _ref2.elementText,
    elementValue = _ref2.elementValue,
    force = _ref2.force,
    region_name = _ref2.region_name;
  return {
    type: SpecType.INTERACTION,
    data: {
      interaction: {
        type: subType === SubType.CLICK ? SubType.CLICK : SubType.TYPED,
        element: _objectSpread(_objectSpread(_objectSpread({
          name: info
        }, elementText && {
          text: elementText
        }), {}, {
          type: elementType !== null && elementType !== void 0 ? elementType : ElementType.BUTTON
        }, elementValue && {
          value: elementValue
        }), {}, {
          region_name: region_name
        })
      }
    },
    version: 3,
    options: {
      force: force !== null && force !== void 0 ? force : true
    }
  };
};
var getSuccessEvent = function getSuccessEvent(_ref3) {
  var info = _ref3.info,
    force = _ref3.force,
    coupon_details = _ref3.coupon_details;
  return {
    type: SpecType.SUCCESS,
    data: {
      name: info,
      state: 'success',
      content: {
        metadata: _objectSpread({}, coupon_details && {
          coupon: coupon_details
        })
      }
    },
    options: {
      force: force !== null && force !== void 0 ? force : true
    },
    version: 4
  };
};
var getNotificationEvent = function getNotificationEvent(_ref4) {
  var subType = _ref4.subType,
    info = _ref4.info,
    message_detail = _ref4.message_detail,
    message_id = _ref4.message_id,
    force = _ref4.force;
  return {
    type: SpecType.NOTIFICATION,
    data: {
      notifications: {
        type: subType,
        message_name: info,
        message_detail: message_detail || '',
        message_id: message_id
      }
    },
    version: 3,
    options: {
      force: force !== null && force !== void 0 ? force : true
    }
  };
};
var getPurchaseEvent = function getPurchaseEvent(purchaseEvent, force) {
  return {
    type: SpecType.PURCHASE,
    data: purchaseEvent,
    version: 3,
    options: {
      force: force !== null && force !== void 0 ? force : true
    }
  };
};
export var getPricingDataProductDetails = function getPricingDataProductDetails(_ref5) {
  var _eligibility$price, _eligibility$currency, _eligibility$price2;
  var pricingData = _ref5.pricingData,
    isUpgrade = _ref5.isUpgrade;
  var externalId = pricingData.externalId,
    eligibility = pricingData.eligibility;
  var productType = externalId === 'CHGStudyPcknoFT' && isUpgrade ? '3B_Swap' : ExternalIdProductTypeMap[pricingData.externalId];
  return {
    product_id: externalId,
    product_type: productType,
    display_price: Number((_eligibility$price = eligibility.price) === null || _eligibility$price === void 0 ? void 0 : _eligibility$price.price),
    currency_code: (_eligibility$currency = eligibility.currencyDetails) === null || _eligibility$currency === void 0 ? void 0 : _eligibility$currency.currencyCode,
    access_length: getBillingCycleContentKey((_eligibility$price2 = eligibility.price) === null || _eligibility$price2 === void 0 ? void 0 : _eligibility$price2.billingPeriod)
  };
};
export var getNextInteractionProductDetails = function getNextInteractionProductDetails(_ref6) {
  var _nextInteractionRespo;
  var nextInteractionResponse = _ref6.nextInteractionResponse,
    countryCode = _ref6.countryCode;
  if (!((_nextInteractionRespo = nextInteractionResponse.data) !== null && _nextInteractionRespo !== void 0 && _nextInteractionRespo.payload)) return undefined;
  var _nextInteractionRespo2 = nextInteractionResponse.data.payload,
    products = _nextInteractionRespo2.products,
    productType = _nextInteractionRespo2.productType,
    action = _nextInteractionRespo2.action;
  return products === null || products === void 0 ? void 0 : products.map(function (product) {
    var isUpgrade = getIsUpgradeEligible({
      action: action,
      products: products,
      productType: productType,
      countryCode: countryCode
    });
    return getPricingDataProductDetails({
      pricingData: product,
      isUpgrade: isUpgrade
    });
  });
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/commerce-utils/dist/esm/utils/RioUtils/rioHelper.js
// module id = 472
// module chunks = 11